import React, { useState } from 'react'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../../images/nodata.png';
import Loader from '../../../../presentationals/Loader/Loader.component';

const itemsPerPage = 10;

export default function List({ handlePage }) {
    const [loader, setLoader] = useState(false)
    const [tableData, setTableData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, settotalCount] = useState(0)

    const handlebtnclick = (type, data) => {

    }


    const handlePageChange = (event, value) => {
        setCurrentPage(value);

    };
    return (
        <>
            <div className="Executor">
                <div className="container-fluid">
                    <div style={{ margin: '20px 0 40px 0', display: 'flex', alignItems: 'center' }}>
                        <h3><b>Ev Loan List</b></h3>

                        <button className='searchbtn btn btn-primary' onClick={() => handlePage('edit')} style={{ marginLeft: '15px', padding: '8px 10px' }}><i class="fa fa-plus fa-lg" aria-hidden="true"></i></button>
                    </div>
                    {
                        loader ?
                            <Loader />
                            : ''
                    }
                    {
                        tableData && tableData?.length > 0 ?
                            <div className='tableedit' >
                                <div className="phocket-table-new" style={{ overflowX: 'auto', marginTop: '0px', marginBottom: '30px' }}>
                                    <table style={{ marginBottom: '10px' }}>
                                        <thead>
                                            <tr>
                                                <th>Scheme Name</th>
                                                <th>Scheme Code</th>
                                                <th>Product Type</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableData?.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data?.schemeName}</td>
                                                    <td>{data?.schemeCode}</td>
                                                    <td>{data?.productType}</td>
                                                    <td>{data?.startDate}</td>
                                                    <td>{data?.endDate}</td>
                                                    <td>{data?.status}</td>
                                                    <td>
                                                        <div className='edits'>
                                                            <i class="fa fa-pencil-square-o fa-lg" aria-hidden="true" onClick={() => handlebtnclick('edit', data)}></i>
                                                            <i class="fa fa-trash-o fa-lg" aria-hidden="true" onClick={() => handlebtnclick('delete', data)}></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ float: 'right', marginTop: '20px' }}>
                                    <Pagination
                                        count={Math.ceil(totalCount / itemsPerPage)}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div>
                            </div>
                            :
                            <p style={{ marginTop: '100px' }} className="text-center">
                                <img src={NodataImage} style={{ width: '30%' }} />
                            </p>
                    }
                </div>
            </div>
        </>
    )
}
